<template>
  <section class="service-enquiry-form">
    <section class="mx-auto w-80">
      <el-tag v-if="success" type="success" class="text-center block">{{ success }}</el-tag>
      <section class="product-service-enquiry-form">
        <el-row>
          <el-col :lg="24" :xs="24">
            <div class="section-heading">
              <h3>Service Enquiry</h3>
            </div>
            <el-form ref="form" :model="service_enquiry" label-position="top">
              <el-row :gutter="30">
                <el-col :md="8">
                  <el-form-item>
                    <el-input v-model="service_enquiry.name" placeholder="Name"></el-input>
                    <p class="error" v-if="getErrors && getErrors.name">{{ getErrors.name }}</p>
                  </el-form-item>
                </el-col>
                <el-col :md="8">
                  <el-form-item>
                    <el-input v-model="service_enquiry.email" placeholder="Email"></el-input>
                    <p class="error" v-if="getErrors && getErrors.email">{{ getErrors.email }}</p>
                  </el-form-item>
                </el-col>
                <el-col :md="8">
                  <el-form-item>
                    <el-input
                      v-model="service_enquiry.device_id"
                      placeholder="Device Serial Number"
                    ></el-input>
                    <p
                      class="error"
                      v-if="getErrors && getErrors.device_id"
                    >{{ getErrors.device_id }}</p>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="30">
                <el-col :md="24">
                  <el-form-item>
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 5, maxRows: 4}"
                      placeholder="Service Enquiry..."
                      v-model="service_enquiry.service_enquiry"
                    ></el-input>
                    <p
                      class="error"
                      v-if="getErrors && getErrors.service_enquiry"
                    >{{ getErrors.service_enquiry }}</p>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="upload-row">
                <el-col :md="12" :xs="24">
                  <span class="upload-title">File Upload</span>
                  <el-upload
                    class="upload-demo"
                    action="#"
                    :on-change="handleChange"
                    :file-list="fileList"
                    :auto-upload="false"
                    accept=".jpeg, .jpg, .png, .pdf"
                  >
                    <el-button size="small" type="primary">Browse Files</el-button>
                    <div slot="tip" class="el-upload__tip">Maximum file size is 5MB</div>
                  </el-upload>
                  <p class="error" v-if="getErrors && getErrors.file">{{ getErrors.file }}</p>
                </el-col>
                <el-col :md="12" :xs="24">
                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="submit"
                      :loading="loading"
                      class="btn submit-btn"
                    >Send</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </section>
    </section>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      success: "",
      fileList: [],
      service_enquiry: {
        name: "",
        email: "",
        device_id: "",
        service_enquiry: ""
      },
      file: null
    };
  },
  computed: {
    ...mapGetters("errors", ["getErrors", "getMessage"])
  },
  methods: {
    handleChange(file, fileList) {
      this.file = file.raw;
      fileList;
    },
    async submit() {
      this.loading = true;
      const form = new FormData();
      form.append("name", this.service_enquiry.name);
      form.append("email", this.service_enquiry.email);
      form.append("device_id", this.service_enquiry.device_id);
      form.append("service_enquiry", this.service_enquiry.service_enquiry);
      form.append("file", this.file);

      await this.$store.dispatch("service_enquiry/enquiry", form);
      this.loading = false;
      if (this.getMessage) {
        this.success = this.getMessage;
        this.$refs["form"].resetFields();
        this.service_enquiry = {
          name: "",
          email: "",
          device_id: "",
          service_enquiry: ""
        };
        this.file = "";
        this.fileList = [];
      }
    }
  }
};
</script>

<style lang="scss">
.el-tag.el-tag--success {
  background-color: #67c23a !important;
  border-color: #e1f3d8;
  color: #ffffff !important;
  font-family: "Work Sans", sans-serif;
  border-radius: 0 !important;
}
.service-enquiry-form {
  font-family: "Work Sans", sans-serif;
  background: rgba(17, 35, 63, 0.09);
  padding: 2rem 0;
  .service-enquiry-content {
    text-align: center;

    .section-heading {
      margin-bottom: 15px;

      h3 {
        font-size: 1.4em;
        line-height: 31px;
        color: #11233f;
      }
    }

    p {
      color: #767676;
    }
  }

  .product-details {
    .product-image img {
      width: 120px;
    }

    .product-content {
      h3 {
        font-size: 1.2em;
        text-transform: uppercase;
        color: #000000;
        margin-bottom: 10px;
      }

      p {
        font-size: 0.9em;
        opacity: 0.8;
        line-height: 170%;
        color: #000000;
      }
    }

    .product-price {
      p {
        font-weight: 500;
        font-size: 24px;
      }
    }
  }

  .product-service-enquiry-form {
    margin-top: 20px;

    input::placeholder {
      font-family: "Work Sans", sans-serif;
    }

    .section-heading {
      h3 {
        font-size: 1.4em;
        color: #000;
      }
    }

    .submit-btn {
      background: #12ab0f;
      border-radius: 6px;
      float: right;
      padding: 12px 55px;
      font-style: normal;
      font-weight: bold;
      font-family: "Work Sans", sans-serif;
    }
  }

  .upload-title {
    display: inline;
    margin-right: 15px;
    color: #7b7a7a;
    font-size: 0.9em;
  }

  .upload-demo {
    display: inline;

    button {
      color: #7b7a7a;
      font-size: 1.1em;
      line-height: 34px;
      border: 1px solid #a8a8a8;
      transition: all 0.3s ease-in;
      &:hover,
      &:focus,
      &:active {
        background: #fff;
        border-style: dashed;
      }
    }

    .el-upload__tip {
      color: #7b7a7a;
      margin-left: 75px;
    }
  }

  .upload-row {
    margin-top: 15px;
  }
}

.upload-row {
  margin-top: 15px;
}

@media (min-width: 0px) and (max-width: 576px) {
  .service-enquiry-form {
    padding: 2em 0;

    .product-service-enquiry-form {
      margin-top: 50px !important;
    }

    .section-heading {
      h3 {
        font-size: 18px !important;
      }
    }

    .product-details {
      .el-row {
        flex-wrap: wrap;
      }

      .product-image {
        img {
          width: 60px !important;
        }
      }

      .product-content h3 {
        font-size: 1em !important;
      }

      .product-price {
        margin-top: 15px;
        text-align: center;

        p {
          font-size: 1.4em !important;
        }
      }
    }
  }
  .submit-btn {
    float: none !important;
    display: table;
    margin: 0 auto;
  }
}
</style>
